import { Moment } from 'moment-timezone';

export const getMinimumStayToDate = (fromDate: Moment, toDate?: Moment): Moment =>
  toDate?.isAfter(fromDate, 'day') ? toDate : fromDate.clone().add(1, 'day');
